import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer } from 'react-sortable-hoc';

import GalleryPhotoBlock from 'admin-editor/components/GalleryPhotoBlock';
import EditContainer from 'styled/Editor/Container';

export class GalleryPhotoList extends React.PureComponent {
  render() {
    return (
      <EditContainer style={{ flexDirection: 'column' }}>
        {this.props.galleryFiles.map((photo, index) => (
          photo.image && (
            <GalleryPhotoBlock
              order={index}
              index={index}
              key={photo.id || photo.image.medialibItemId}
              photoSrc={photo.image.url}
              title={photo.title}
              onRemove={this.props.onRemove}
              onTitleChange={this.props.onTitleChange}
            />
          )
        ))}
      </EditContainer>
    );
  }
}

GalleryPhotoList.propTypes = {
  galleryFiles: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.shape({
      medialibItemId: PropTypes.string.isRequired,
      url: PropTypes.string,
    }),
  })),
  onRemove: PropTypes.func,
  onTitleChange: PropTypes.func,
};

GalleryPhotoList.defaultProps = {
  galleryFiles: [],
  onRemove: () => {},
  onTitleChange: () => {},
};

export default SortableContainer(GalleryPhotoList);
